// import getApiSdk from '@apiSdk';
import getApiSdk from '@api-sdk';
import { AiScriptGeneratorParamsSchema } from '@sendspark/js-api-sdk';

export const generateScript = async (
  payload: AiScriptGeneratorParamsSchema,
  options?: any
): Promise<any> => {
  const response = await getApiSdk.postAiScriptsGenerator(payload, options);
  return response.data;
};
